// @flow
import { useField } from 'react-final-form';

import { InputText } from '@gandi/form';
import { FinalFormGroup } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Svg } from '@gandi/ui';

import styles from './DiscountInput.scss';

type Props = { success: ?string, handleClear: () => void };
export function DiscountInput({
  handleClear,
  success,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const { input } = useField('discount-code');

  return (
    <FinalFormGroup
      name="discount-code"
      help={
        success ? (
          <span className={styles.discountAdded}>
            <Svg id="successWire" name="successWire" theme="success" />
            {__('Discount added to your cart.')}
          </span>
        ) : undefined
      }
    >
      <InputText
        name="discount-code"
        id="discount-code"
        {...input}
        onChange={e => {
          input.onChange(e);
          handleClear();
        }}
        className={styles.input}
        placeholder={__('Enter promo code here')}
      />
    </FinalFormGroup>
  );
}
